import type { LogFacets, LogSection, RunChannel, RunStatus, SectionFilters } from './types';

/** URL segment of the module under an agent (`assistants/:AssistantID/observability`). */
export const OBSERVABILITY_ROUTE_SEGMENT = 'observability';

/**
 * The two sections of the log, both always shown while the log reads a mock.
 * Which ones apply to an agent (by its type, a permission or its data) is decided
 * with the backend — AC5 is deferred to that integration.
 */
export const LOG_SECTIONS: readonly LogSection[] = ['conversations', 'processRuns'];

/** Rows fetched per page of a section's log (PRD NFR: never load the whole log at once). */
export const RUNS_PAGE_SIZE = 25;

/** Placeholder rows while a section's first page loads. */
export const SKELETON_ROWS = 6;

/**
 * How long a loaded section stays fresh. A tab remounts when it is selected again,
 * and an infinite query refetches every loaded page on mount — without this, each
 * switch would replay every page already scrolled into.
 */
export const RUNS_STALE_TIME_MS = 60_000;

/** The statuses a run can be filtered by, in the order the filter lists them. */
export const RUN_STATUSES: readonly RunStatus[] = ['completed', 'failed', 'running'];

/** Every channel, in the catalog order the channel filter lists them. */
export const RUN_CHANNELS: readonly RunChannel[] = ['whatsapp', 'webchat', 'webvoice', 'phone'];

/** The channels where a conversation is a call, so its detail reads as a transcript. */
export const VOICE_CHANNELS: ReadonlySet<RunChannel> = new Set<RunChannel>(['phone', 'webvoice']);

/** Pause after the last keystroke before the search reaches the query. */
export const SEARCH_DEBOUNCE_MS = 300;

/** An agent with no runs, or facets still loading: every option list empty. */
export const NO_FACETS: LogFacets = { channels: [], subagents: [], skills: [] };

/** Nothing narrowed: what each section starts with and what "Clear filters" restores. */
export const NO_FILTERS: SectionFilters = {
  conversations: { search: '', channels: [] },
  processRuns: { search: '' },
};
